import axios from 'axios';
import { toast } from 'react-toastify';

export async function enviarMensagemWhatsApp(telefone, mensagem, bearer, baseurl, externalKey) {
  try {
    const payload = {
      body: mensagem,
      number: telefone,
      isClosed: false,
      externalKey: externalKey || Math.random().toString(36).substring(2, 15)
    };

    const response = await axios.post(baseurl, payload, {
      headers: {
        Authorization: `Bearer ${bearer}`
      }
    });
    toast.success("Mensagem enviada com Sucesso")
    return true;
  } catch (error) {

    toast.error("Erro ao enviar a mensagem")
    console.error('Erro ao enviar mensagem WhatsApp:', error.response?.data || error.message);
    if (error.config) {
      console.error('Dados da requisição que falhou:', {
        url: error.config.url,
        method: error.config.method,
        headers: error.config.headers, // Cuidado ao logar tokens em produção
        data: error.config.data
      });
    }
    return false;
  }
}